import * as actionTypes from "../actionTypes/actionTypes";


const initialState = {
  gridData: {
    data: [],
    isLoading: false,
    hasError: false,
  },
  layerDependencies: {
    data: [],
    isLoading: false,
    hasError: false,
  },
  deleteLayer: {
    data: [],
    isLoading: false,
    hasError: false,
  },
  createLayerRule: {
    data: {},
    isLoading: false,
    hasError: false,
  },
};

export const layerReducer = (state = initialState, action) => {
  const newState = { ...state };
  switch (action.type) {
    
    case actionTypes.GET_LAYER:
      return {
        ...newState,
        gridData: { ...newState.gridData, isLoading: true, hasError: false },
      };
    case actionTypes.GET_LAYER_SUCCESS:
       
      return {
        ...newState,
        gridData: { data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.GET_LAYER_FAILURE:
      return {
        ...newState,
        gridData: { data: action.payload, isLoading: false, hasError: true },
      };
      case actionTypes.GET_LAYER_RULE:
        return {
          ...newState,
          layerDependencies: { ...newState.layerDependencies, isLoading: true, hasError: false }
        };
      case actionTypes.GET_LAYER_RULE_SUCCESS:
        return {
          ...newState,
          layerDependencies: { data: action.payload, isLoading: false, hasError: false },
        };
      case actionTypes.GET_LAYER_RULE_FAILURE:
        return {
          ...newState,
          layerDependencies: { ...newState.configGroups, isLoading: false, hasError: true },
        };
        case actionTypes.DELETE_LAYER_RULE:
        return {
          ...newState,
          deleteLayer: { ...newState.deleteLayer, isLoading: true, hasError: false }
        };
      case actionTypes.DELETE_LAYER_RULE_SUCCESS:
        return {
          ...newState,
          deleteLayer: { data: action.payload, isLoading: false, hasError: false },
        };
      case actionTypes.DELETE_LAYER_RULE_FAILURE:
        return {
          ...newState,
          deleteLayer: { ...newState.deleteLayer, isLoading: false, hasError: true },
        };

      case actionTypes.CREATE_LAYER_RULE:
      return {
        ...newState,
        createLayerRule: { ...newState.createLayerRule, isLoading: true, hasError: false },
      };
    case actionTypes.CREATE_LAYER_RULE_SUCCESS:
      return {
        ...newState,
        createLayerRule: { data: action.payload, isLoading: false, hasError: false },
      };
    case actionTypes.CREATE_LAYER_RULE_FAILURE:
      return {
        ...newState,
        createLayerRule: { data: action.payload, isLoading: false, hasError: true },
      }; 

    default:
      return { ...newState };
  }
};
